import "./src/styles/index.scss";
import withRoot from "./src/with-root";
import withLayout from "./src/with-layout";

export const wrapRootElement = withRoot;
export const wrapPageElement = withLayout
